import React, { useState, useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { InputLabel, Select, MenuItem } from "@mui/material";
import moment from "jalali-moment";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { useParams, useLocation } from "react-router-dom";
import NewMultiSelect from "../../../../components/FormikControls/NewMultiSelect/NewMultiSelect";
import { editKeyResultSchema, kRType } from "../../StaticData/index";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import { Box, Grid, TextField, Typography, FormControl } from "@mui/material";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import { Formik, Form } from "formik";
import { addKrValues } from "../../StaticData/index";
import { DatePicker } from "@mui/x-date-pickers";
import { useGetAllObjectiveDefinitionLevelByTenantId1,useGetAllObjectiveDefinitionLevelByTenantId2 } from "../../Hooks";
import { useGetAllReportingPeriodByTenantId ,useGetAllMeasurementUnitByTenantId} from "../../../IndexManaging/Hooks/Index";
import MultiSel from "../../../../components/MultiSel/MultiSel";
import { ErrorMessage } from "formik";
import {
  useGetAllActivePersonByTenantId,
  useGetAllOKRStateByTenantId,
  useGetAllScoreLevelsByTenantId,
  useGetAllPersonIndexByTenantId,
  useGetAllTenantIndexByTenantId,
} from "../../Hooks";
import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
import { useSelector } from "react-redux";
import { pointSystem, keyResultTypeOptions } from "../../StaticData/index";
import { useGetKeyResultDetailsById, useEditKeyResult } from "../../Hooks";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
import { removeCommas, thousandSeparator } from "../../../../helper/lib";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import VerticalAlignments from "../../new/verticalAlignments2";
import ForEdit from "../CreateKeyResult/ForEdit";
interface createKrFace {
  // addKrSuccess
  editKrSuccess: () => any;
  setShowToastMessage: (show: boolean) => void;
  setShowToastMessage3?: (show: boolean) => void;
  setAddKrState: (show: any) => void;
  setShowEditKeyResult: (show: boolean) => void;
  krId: string | null;
  definitionId: any;
  Item?: any;
}

export const EditKeyResult = ({
  definitionId,
  editKrSuccess,
  setShowToastMessage,
  setShowToastMessage3,
  setAddKrState,
  setShowEditKeyResult,
  krId,
  Item
}: any) => {
  const tenantId: any = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const location: any = useLocation();
  const [krDetailInitValues, setKrDetailInitValues] = useState<any>();
  const [krHorizontalAlignments, setHorizontalAlignments] = useState<any[]>([]);
  const [tval, setTval] = useState<any>(null);
  const [showLToastMessage, setLShowToastMessage] = useState<boolean>(false);
  const [okrStateId, setOkrStateId] = useState<null | string>("");
  const [lstartDate, setlStartDate] = useState<any>("");
  const [lforceEndDate, setlForceEndDate] = useState<any>("");
  const [jlStartDate, setJlStartDate] = useState("");
  const [jlForecDate, setJlForceDate] = useState("");
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage2, setShowLtoastMessage2] = useState<any>(null);
  // let {
  //   state: { objectiveId },
  // }: any = location || {};
  let {
     definitionLevelId,objectiveId , id,
  }: any = Item || {};
  // let {
  //   state: { objectiveId } = { objectiveId: null },
  // } = location || { Item };
  const [pointingSystemType, setPointingSystemType] =
    useState<string>("Regularly");
  const [idsValue, setIdsValue] = useState<any>([]);
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(false);
  const [editAsyncData, setEditAsyncData] = useState<any>(null);
  const [values, setValues] = useState<{ description: string }>({ description: '' });
  const [isEditing, setIsEditing] = useState(true);
  // const{data:HorzinalAlignData}:any=useGetAllHorizontalAlignmentByTenantId(tenantId,definitionId);
  const { data: teamsOptions, isLoading: teamOPloading }: any =
    useGetAllObjectiveDefinitionLevelByTenantId1(tenantId, definitionLevelId);
    const {data:tenantIndexOptions}=useGetAllTenantIndexByTenantId(tenantId);
    const {data:personIndexOptions}=useGetAllPersonIndexByTenantId(tenantId);
    const {data:reportingPeriodData,isLoading:reportingPeriodDataLoading}=useGetAllReportingPeriodByTenantId(tenantId);
    const {data:measurementUnitData,isLoading:measurementUnitDataLoading}=useGetAllMeasurementUnitByTenantId(tenantId);
    const { data: ObjectiveNameOptions } =
    useGetAllObjectiveDefinitionLevelByTenantId2(tenantId,objectiveId);
  const { data: acPersOptions }: any =
    useGetAllActivePersonByTenantId(tenantId);
  const { data: submitFormOptions }: any =
    useGetAllOKRStateByTenantId(tenantId);
  const { data: levelIds, isFetched: getLevelsIds }: any =
    useGetAllScoreLevelsByTenantId(tenantId);
  const [hundredValue, setHundredValue] = useState<any>({
    value: "",
    scoreLevelId: "",
    tenantId: tenantId,
  });
  const {
    data: krDetailsData,
    isLoading: krDetLoading,
    isFetched: kerDetFetched,
  }: any = useGetKeyResultDetailsById(krId);

  const localEditKrSuccess = () => {
    setHorizontalAlignments([]);
  };
  const [showVerticalAlignment, setShowVerticalAlignment] =
  useState<boolean>(false);
  const [verticalAlignmentBaseData, setVerticalAlignmentBaseData] =
  useState<any>([]);

  const {
    data: editKrData,
    mutate: callEditKR,
    isSuccess,
    isError,
    isLoading: editLoading,
  } = useEditKeyResult(localEditKrSuccess);
  // const[teamAsynOpcState,setTeamAsyncOpState]=useState<any>(null);

  const initialEditKr = (data: any) => {
    let ids =
      pointingSystemType === "Regularly" ? [{ ...hundredValue }] : idsValue;
      const verticalAlignmentLocal: Array<string> = [];
      verticalAlignmentBaseData.map((group: any) => ({
        ...group,
        items: group.items.map(
          (item: any) => item.checked && verticalAlignmentLocal.push(item.id)
        ),
      }));
    let horval = krHorizontalAlignments?.map(({ value }: any) => value);
    let { forceEndDate, startDate, horizontalAlignments, ...rest } = data;

    let totalData = {
      ...rest,
      tenantId: tenantId,
      objectiveId: objectiveId,
      horizontalAlignments: [...horval],
      onValue: "",
      forceEndDate: jlForecDate,
      startDate: jlStartDate,
      oKRStateId: okrStateId,
      keyResultParentIds: verticalAlignmentLocal,
    };
    totalData.valuesDetailCommandDtos = ids;
    totalData.onValue = "";
    console.log(totalData);

    callEditKR(totalData);
  };

  useEffect(() => {
    if (ObjectiveNameOptions) {
      const localVerticalAlignmentBaseData = ObjectiveNameOptions.map(
        (group: any) => ({
          ...group,
          items: group.items.map((item: any) => ({ ...item, checked: false })),
        })
      );

      setVerticalAlignmentBaseData(localVerticalAlignmentBaseData);
    }
  }, [ObjectiveNameOptions]);

  const[repoData,setRepoData]=useState([])
  useEffect(() => {
    if(reportingPeriodData !== null && reportingPeriodData !== undefined ){
      setRepoData(reportingPeriodData);
    }
  }, [reportingPeriodData]);

  const[measData,setMeasData]=useState([])
  useEffect(() => {
    if(measurementUnitData !== null && measurementUnitData !== undefined ){
      setMeasData(measurementUnitData);
    }
  }, [measurementUnitData]);
  const [showAdvanceOptions, setShowAdvanceOptions] = useState<Boolean>(false);

  useEffect(() => {
    setIdsValue(
      levelIds?.map((item: any) => {
        return { ...item, tenantId: tenantId };
      })
    );
  }, [getLevelsIds]);

  useEffect(() => {
    let finded: any = levelIds?.find((o: any) => o.name === "1")?.scoreLevelId;
    setTval(finded);
    setHundredValue((prev: any) => {
      return { ...prev, scoreLevelId: finded };
    });
  }, [levelIds]);

  useEffect(() => {
    if (lforceEndDate !== "") {
      setJlForceDate(moment(lforceEndDate).format("jYYYY/jM/jD"));
    }
  }, [lforceEndDate]);

  // useEffect(() => {
  //   if (lforceEndDate instanceof Date && !isNaN(lforceEndDate.getTime())) {
  //     setJlForceDate(moment(lforceEndDate).format("jYYYY/jM/jD"));
  //   } else {
  //     setJlForceDate(""); // مقدار پیش‌فرض برای حالت نامعتبر
  //   }
  // }, [lforceEndDate]);
    useEffect(() => {
    if (lstartDate !== "") {
      setJlStartDate(moment(lstartDate).format("jYYYY/jM/jD"));
    }
  }, [lstartDate]);
  // تبدیل تاریخ شروع (lstartDate) به فرمت جلالی
  // useEffect(() => {
  //   if (lstartDate instanceof Date && !isNaN(lstartDate.getTime())) {
  //     setJlStartDate(moment(lstartDate).format("jYYYY/jM/jD"));
  //   } else {
  //     setJlStartDate(""); // مقدار پیش‌فرض برای حالت نامعتبر
  //   }
  // }, [lstartDate]);

  useEffect(() => {
    if (editKrData) {
      if (editKrData?.data.isSuccess) {
        setShowEditKeyResult(false);
        setAddKrState(editKrData?.data);
        editKrSuccess();
        setShowToastMessage(true);
      } else {
        setLShowToastMessage(true);
        setEditAsyncData(editKrData?.data);
      }
    }
  }, [editKrData, isSuccess]);

  useEffect(() => {
    if (editKrData) {
      if (editKrData?.data.isSuccess) {
        setShowToastMessage3(true);
        SetIsSuccess(true);
        SetTMessage(editKrData?.data.metaData.message);
        setShowEditKeyResult(false);
      } else {
        setShowLtoastMessage2(true);
        SetIsSuccess(false);
        SetTMessage(editKrData?.data.metaData.message);
        // setAddObjError(editKrData?.data);
      }
    }
  }, [editKrData]);

  useEffect(() => {
    setHorizontalAlignments([]);
    if (krDetailsData) {
      let {
        name,
        nameType,
        indexId,
        responsibleId,
        startValue,
        kRType,
        reportingPeriodId,
        displayPriority,
        measurementUnitId,
        // pointingSystemTypeValue,
        okR_KeyResultTypeValue,
        okR_KRType,
        oneValue,
        weight,
        forceEndDateRealDate,
        id,
        description,
        startDateRealDate,
        okR_GradeDetails,
        pointingSystemTypeValue,
        horizontalAlignments,
        verticalAlignments2
      } = krDetailsData;
      if (forceEndDateRealDate !== null) {
        setlForceEndDate(new Date(forceEndDateRealDate));
      }

      if (startDateRealDate !== null) {
        setlStartDate(new Date(startDateRealDate));
      }

      setHundredValue((prev: any) => {
        return { ...prev, value: oneValue };
      });

      setPointingSystemType(pointingSystemTypeValue);
      if (horizontalAlignments !== null) {
        setHorizontalAlignments(
          horizontalAlignments?.map(({ name, id }: any) => {
            return { value: id, key: name };
          })
        );
      }

      if (pointingSystemTypeValue === "Tensile") {
        setIdsValue(
          okR_GradeDetails?.map(
            ({ scoreLevelId, value, tenantId, ...rest }: any) => {
              return { tenantId, value, scoreLevelId };
            }
          )
        );
      }

      let initValue = {
        name: name,
        reportingPeriodId:reportingPeriodId,
        measurementUnitId:measurementUnitId,
        okR_KRType:okR_KRType,
        responsibleId: responsibleId,
        startValue: startValue,
        pointingSystemType: pointingSystemTypeValue,
        keyResultType: okR_KeyResultTypeValue,
        onValue: oneValue,
        indexId:indexId,
        displayPriority:displayPriority,
        nameType:nameType,
        weight: String(weight),
        forceEndDate: forceEndDateRealDate
          ? new Date(forceEndDateRealDate)
          : "",
        startDate: startDateRealDate ? new Date(startDateRealDate) : "",
        id: id,
        description: description,
      };

      if (ObjectiveNameOptions) {
        const localVerticalAlignmentBaseData = ObjectiveNameOptions.map(
          (group: any) => ({
            ...group,
            items: group.items.map((item: any) =>
              verticalAlignments2.findIndex(
                (vItem: any) => vItem.id === item.id
              ) > -1
                ? { ...item, checked: true }
                : { ...item, checked: false }
            ),
          })
        );

        setVerticalAlignmentBaseData(localVerticalAlignmentBaseData);
      }

      setKrDetailInitValues(initValue);
    }
  }, [krDetailsData]);

  useEffect(() => {
    let finded: any = levelIds?.find((o: any) => o.name === "1");
    setTval(finded?.scoreLevelId);
  }, [levelIds]);

  useEffect(() => {
    if (isError) {
      setLShowToastMessage(true);
    }
  }, [isError, editKrData]);

  const initialUpdateIdsValue = (i: number, item: any) => {
    setIdsValue((prev: any) =>
      prev.map((o: any, index: number) =>
        index === i ? { ...o, value: item } : o
      )
    );
  };

  const initialSetHunderdvalue = (value: any) => {
    let iniVal = {
      scoreLevelId: tval,
      value: value,
      tenantId: tenantId,
    };
    // console.log(iniVal)
    setHundredValue(iniVal);
  };

  if (krDetLoading) {
    return (
      <Box py={6} textAlign={"center"}>
        <CircularProgress />
      </Box>
    );
  }


  const setFieldValue = (field: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };
  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        {false ? (
          <Box py={6} textAlign={"center"}>
            <CircularProgress />
          </Box>
        ) : (
          <Formik
            enableReinitialize
            initialValues={krDetailInitValues}
            validationSchema={editKeyResultSchema}
            onSubmit={(data) => {
              initialEditKr(data);
            }}
          >
            {({
              values,
              setFieldValue,
              dirty,
              isValid,
              touched,
              errors,
              setFieldTouched,
            }: any) => (
              <Form>
                <Grid container>
                  {/* <Grid item xs={12} md={3}>
                    <Box sx={{ padding: "8px" }}>
                      <TextField
                        size="small"
                        fullWidth
                        label='شرح نتیجه کلیدی'
                        value={values?.name || ""}
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("name", value);
                        }}
                      />
                    </Box>
                  </Grid> */}
                     <Grid item xs={12} md={12} >
                       <span className="items-center">انتخاب نتیجه کلیدی:</span>
                    </Grid>
                    <div className="h-11 w-full flex gap-x-8 items-center">
                        <label className="flex gap-x-2 w-1/6 items-center">
                        <input
                            type="radio"
                            className="radio radio-xs"
                            name="fromTenantBank"
                            value="fromTenantBank"
                            id="fromTenantBank"
                            onChange={() => setFieldValue("nameType", "fromTenantBank")}
                            checked={values?.nameType === "fromTenantBank"}
                        />
                        <span className=" text-xs">از لیست شرکت</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                        <input
                            type="radio"
                            className="radio radio-xs"
                            name="fromMyBank"
                            value="fromMyBank"
                            id="fromMyBank"
                            onChange={() => setFieldValue("nameType", "fromMyBank")}
                            checked={values?.nameType === "fromMyBank"}
                        />
                        <span className=" text-xs">
                            از لیست من
                        </span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                        <input
                            type="radio"
                            className="radio radio-xs"
                            name="normal"
                            value="normal"
                            id="normal"
                            onChange={() => setFieldValue("nameType", "normal")}
                            checked={values?.nameType === "normal"}
                        />
                        <span className=" text-xs">
                        عادی
                        </span>
                        </label>
                        <div className="w-3/6">
                        {values?.nameType === "fromTenantBank" ? 
                            <div className=" relative cursor-pointer ">
                            <Grid item xs={12} md={12}>
                            <FormikControl
                                        control='select'
                                        options={tenantIndexOptions||[]}
                                        label="انتخاب از لیست شرکت "
                                        name='indexId'
                                        fullWidth
                                        value={values?.indexId}
                                    />
                            </Grid>
                            </div>
                        
                        : values?.nameType === "fromMyBank" ?
                            <div className=" relative cursor-pointer ">
                            <Grid item xs={12} md={12}>
                            <FormikControl
                                        control='select'
                                        options={personIndexOptions||[]}
                                        label="انتخاب از لیست من"
                                        name='indexId'
                                        fullWidth
                                        value={values?.indexId}
                                    />
                            </Grid>
                            </div>
                        :
                        <div className=" relative cursor-pointer ">
                            {/* <Grid item xs={12} md={12}  >
                            <FormikControl
                                control='textField'
                                type='text'
                                label='شرح نتیجه کلیدی'
                                name='name'
                                fullWidth
                                value={values?.name}
                            />
                                </Grid> */}
                  <Grid item xs={12} md={12}>
                    <Box sx={{ padding: "8px" }}>
                      <TextField
                        size="small"
                        label='شرح نتیجه کلیدی'
                        name="name"
                        fullWidth
                        value={values?.name || ""}
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("name", value);
                        }}
                      />
                    </Box>
                  </Grid>
                                </div>
                        }
                        </div>
                    </div> 
                   <Grid item xs={12} md={3}>
                    <FormikControl
                      control="select"
                      options={acPersOptions || []}
                      label="مسئول"
                      name="responsibleId"
                      fullWidth
                      value={values?.responsibleId || ""}
                    />
                  </Grid> 
                  <Grid item xs={12} md={3}>
                    <Box sx={{ padding: "8px" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          سیستم امتیاز دهی{" "}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .muirtl-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
                              { py: "1px" },
                          }}
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values?.pointingSystemType || ""}
                          label="سیستم امتیاز دهی "
                          onChange={({ target }: any) => {
                            let { value } = target;
                            //    setFieldValue('pointingSystemType',value)
                            setPointingSystemType(value);
                            setFieldValue("pointingSystemType", value);
                          }}
                        >
                          {pointSystem.map((item: any, i: number) => {
                            let { key, value, desc } = item;
                            return (
                              <MenuItem
                                key={i}
                                sx={{
                                  fontSize: "0.7rem",
                                  bgcolor: "transparent",
                                }}
                                value={value}
                              >
                                {key}
                                {"\u00A0"}
                                <Typography fontSize={"0.5rem"}>
                                  {desc}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormikControl
                      control="select"
                      options={keyResultTypeOptions}                      
                      label="نوع نتیجه کلیدی "
                      name="keyResultType"
                      fullWidth
                      value={values?.keyResultType || ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormikControl
                      control="select"
                      isLoading={measurementUnitDataLoading}
                      options={measData || {}}
                       label="واحد سنجش"
                       name="measurementUnitId"
                      fullWidth
                      value={values?.measurementUnitId || ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                     <Box sx={{ padding: "10px" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                        منطق گزارش دهی {" "}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .muirtl-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
                              { py: "5px" },
                          }}
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values?.reportingPeriodId || ""}
                            label="منطق گزارش دهی "
                          onChange={({ target }: any) => {
                            let { value } = target;
                            setFieldValue("reportingPeriodId", value);
                          }}
                        >
                          {repoData.map((item: any, i: number) => {
                            let { key, value, desc } = item;
                            return (
                              <MenuItem
                                key={i}
                                sx={{
                                  fontSize: "0.7rem",
                                  bgcolor: "transparent",
                                }}
                                value={value}
                              >
                                {key}
                                {"\u00A0"}
                                <Typography fontSize={"0.5rem"}>
                                  {desc}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Box sx={{ padding: "8px" }}>
                      <TextField
                        size="small"
                        fullWidth
                        label={"مقدار شروع "}
                        value={
                          values?.keyResultType === "Numerical"
                            ? thousandSeparator(values?.startValue || "")
                            : values?.startValue || ""
                        }
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("startValue", removeCommas(value));
                        }}
                      />
                    </Box>
                  </Grid>

                  {pointingSystemType === "Regularly" ? (
                    <Grid item xs={12} md={3}>
                      <Box sx={{ padding: "8px" }} width={"100%"}>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          label={'مقدار معادل امتیاز 100% (مقدار آرمانی)'}
                          value={
                            values?.keyResultType === "Numerical"
                              ? thousandSeparator(hundredValue.value || "")
                              : hundredValue.value || ""
                          }
                          //   value={hundredValue.value}
                          onChange={({ target }: any) => {
                            let { value } = target;
                            initialSetHunderdvalue(removeCommas(value));
                          }}
                        />
                      </Box>
                    </Grid>
                  ) : (
                    <>
                      {idsValue?.map((item: any, i: number) => {
                        return (
                          <Grid item key={i} xs={12} md={3} padding={"8px"}>
                            <TextField
                              fullWidth
                              size="small"
                              //   value={idsValue[i]?.value || ""}
                              value={
                                values?.keyResultType === "Numerical"
                                  ? thousandSeparator(idsValue[i]?.value || "")
                                  : idsValue[i]?.value || ""
                              }
                              onChange={({ target }: any) => {
                                let { value }: any = target;
                                // console.log(value)
                                initialUpdateIdsValue(i, removeCommas(value));
                              }}
                              label={
                                i===0?'مقدار معادل امتیاز 30% (بهبود کم)':i===1?'مقدار معادل امتیاز 70%(تارگت/بهبود عالی)':'مقدار معادل امتیاز 100% (مقدار آرمانی)'
                              }
                            />
                          </Grid>
                        );
                      })}
                    </>
                  )}

                      <Grid xs={12} md={5} mt={1}>
                        <div className=" relative cursor-pointer ">
                          <div
                            onClick={(e: React.MouseEvent<HTMLElement>) => {
                              e.preventDefault();
                              setShowVerticalAlignment(!showVerticalAlignment);
                            }}
                            className={` px-2 w-[98%] py-2 mt-1 flex justify-between text-xs font-thin text-black 
                            
                              rounded-md  ml-3 border-2 ${
                                showVerticalAlignment
                                  ? "border-sky-600"
                                  : "border-slate-200"
                              }   `}
                          >
                            همسویی عمودی نتیجه کلیدی
                            {showVerticalAlignment ? (
                              <ArrowDropUpIcon />
                            ) : (
                              <ArrowDropDownIcon />
                            )}
                          </div>

                          {showVerticalAlignment && verticalAlignmentBaseData && (
                            <div className="absolute w-[98%] top-full right-0">
                              <VerticalAlignments
                                data={verticalAlignmentBaseData}
                                setShowVerticalAlignment={setShowVerticalAlignment}
                                setCheckBoxes={(id: string) => {
                                  let tmpData: any = verticalAlignmentBaseData.map(
                                    (group: any) => ({
                                      ...group,
                                      items: group.items.map((item: any) =>
                                        item.id === id
                                          ? { ...item, checked: !item.checked }
                                          : { ...item }
                                      ),
                                    })
                                  );
                                  setFieldValue("keyResultParentIds", ["isDirty"]);
                                  setVerticalAlignmentBaseData(tmpData);
                                }}
                              ></VerticalAlignments>
                            </div>
                          )}
                        </div>
                        </Grid>

                  <Grid item xs={12}>
                    <AccordionLyt
                      collapse={setShowAdvanceOptions}
                      title={" تنظیمات پیشرفته ( اختیاری)"}
                      //   showAdvanceOptions,setShowAdvanceOptions
                      expanded={showAdvanceOptions}
                    >
                      <Grid container>
                        <Grid item xs={12} md={1.5}>
                          <Box>
                            <div className="error">
                              <ErrorMessage name="weight" />
                            </div>
                            <FormikControl
                              control="textField"
                              size="small"
                              name="weight"
                              fullWidth
                              label={"وزن"}
                              value={values?.weight || 0}
                              onChange={({ target }: any) => {
                                let { value } = target;
                                if (value) {
                                  setFieldValue("weight", value);
                                } else {
                                  setFieldValue("weight", null);
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={1.5}>
                        <Box sx={{ padding: "8px", fontSize: 10 }}>
                        <TextField
                        sx={{ fontSize: 10 }}
                        size="small"
                        type="number" // نوع فیلد را به عدد تغییر دادیم
                        label="اولویت نمایش" // عنوان فیلد
                        name="displayPriority" // نام فیلد
                        fullWidth
                        value={values?.displayPriority || ""} // مقدار فیلد
                        onChange={({ target }: any) => {
                        let { value } = target;
                        setFieldValue("displayPriority", value); // به‌روزرسانی مقدار فیلد
                        }}
                        />
                        </Box>
                        </Grid>

                        {/* <Grid item xs={12} md={3}>
                          <Box sx={{ padding: "8px" }}>
                            <MultiSel
                              data={teamsOptions || []}
                              extractTag={setHorizontalAlignments}
                              label={"همسویی افقی"}
                              editMode={true}
                              loading={teamOPloading}
                              tagSelected={krHorizontalAlignments}
                            />
                          </Box>
                        </Grid> */}
                        <Grid item xs={12} md={3}>
                    <FormikControl
                      control="select"
                      options={kRType}
                      label="نوع نتیجه کلیدی "
                      name="kRType"
                      fullWidth
                      value={values?.okR_KRType	 || ""}
                    />
                  </Grid>

                        <Grid item xs={12} md={3}>
                          <FormControl sx={{ p: "8px" }} fullWidth>
                            <DatePicker
                              slotProps={{ textField: { size: "small" } }}
                              label={"تاریخ شروع نتایج کلیدی"}
                              value={lstartDate || ""}
                              onChange={(newValue: any) => {
                                var persianDate =
                                  moment(newValue).format("jYYYY/jM/jD");
                                setlStartDate(newValue);
                              }}
                            />
                            {/* <DatePicker
                              slotProps={{
                                textField: {
                                  size: "small",
                                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.key === "Delete" || event.key === "Backspace") {
                                      setlStartDate(null);
                                    }
                                  },
                                },
                              }}
                              label={"تاریخ شروع نتایج کلیدی"}
                              value={lstartDate || null}
                              onChange={(newValue: any) => {
                                setlStartDate(newValue || null);
                              }}
                            /> */}

                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <FormControl sx={{ p: "8px" }} fullWidth>
                            <DatePicker
                              slotProps={{ textField: { size: "small" } }}
                              label={"حداکثر تاریخ انجام"}
                              value={lforceEndDate || ""}
                              onChange={(newValue: any) => {
                                var persianDate =
                                  moment(newValue).format("jYYYY/jM/jD");
                                //    console.log(persianDate)
                                setlForceEndDate(newValue);
                                // console.log(lforceEndDate)
                              }}
                            />
                            {/* <DatePicker
                              slotProps={{
                                textField: {
                                  size: "small",
                                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.key === "Delete" || event.key === "Backspace") {
                                      setlForceEndDate(null); // پاک کردن مقدار تاریخ
                                    }
                                  },
                                },
                              }}
                              label={"حداکثر تاریخ انجام"}
                              value={lforceEndDate || null} // مقدار پیش‌فرض null برای سازگاری
                              onChange={(newValue: any) => {
                                setlForceEndDate(newValue || null); // مقدار جدید یا null
                              }}
                            /> */}

                          </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} md={9}>
                          {/* <Box sx={{ padding: "8px" }}> */}
                            {/* <TextField
                              size="small"
                              fullWidth
                              label={"توضیحات"}
                              value={values?.description || ""}
                              onChange={({ target }: any) => {
                                let { value } = target;
                                setFieldValue("description", value);
                              }}
                            /> */}
                     <ForEdit
        values={values}
        setFieldValue={setFieldValue}
      />
                          {/* </Box> */}
                        </Grid>
                      </Grid>
                    </AccordionLyt>
                  </Grid>

                  <Grid item xs={12} md={12} mt={3}>
                    <Box
                      width={"100%"}
                      display={"flex"}
                      justifyContent={"end"}
                      flexDirection={"row-reverse"}
                      columnGap={2}
                    >
                      {submitFormOptions &&
                        submitFormOptions?.map((item: any, i: number) => {
                          let { label, id } = item;
                          // console.log(item)
                          return (
                            <Box width={"20%"}>
                              <DyButton
                                key={i}
                                // disabled={dirty || !isValid}

                                disabled={editLoading}
                                type={"submit"}
                                variant={"contained"}
                                bgColor={"info"}
                                caption={label}
                                onClick={() => {
                                  // console.log(id)
                                  setOkrStateId(id);
                                }}
                              />
                            </Box>
                          );
                        })}
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}

        {showLToastMessage && (
          <DYToastMessage
            isSuccess={editAsyncData?.isSuccess}
            message={editAsyncData?.metaData.message}
            setShow={setLShowToastMessage}
            show={showLToastMessage}
          />
        )}
         {showLtoastMessage2 && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage2}
            show={showLtoastMessage2}
          />
        )}
      </Box>
    </>
  );
};
